import { render, staticRenderFns } from "./_SystemCardContent.vue?vue&type=template&id=5ed9dc85&scoped=true&"
import script from "./_SystemCardContent.vue?vue&type=script&lang=ts&"
export * from "./_SystemCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./_SystemCardContent.vue?vue&type=style&index=0&id=5ed9dc85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9dc85",
  null
  
)

export default component.exports